<div class="full-width">
  <ng-container *ngIf="model.label" ngProjectAs="mat-label">
    <mat-label [innerHTML]="model.label"></mat-label>
  </ng-container>
  <mat-chip-listbox #chipList [multiple]="model.multiple" [required]="model.required" [disabled]="model.disabled">
    <mat-chip-option
      #chip
      *ngFor="let option of model.options; let i = index"
      [selected]="isOptionSelected(option)"
      [disabled]="model.disabled"
      (selectionChange)="onChipSelectionChange(option, $event.selected)"
      data-test="mat-chip-item"
    >
      {{ option.label }}
    </mat-chip-option>
  </mat-chip-listbox>
  <mat-hint *ngIf="model.hint !== null" align="start" [innerHTML]="model.hint"></mat-hint>
  <mat-error *ngFor="let message of errorMessages">{{ message }}</mat-error>
</div>
